import { AxiosError } from 'axios';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import AlertWithLinkModal from '@app/containers/Modal/AlertWithLinkModal';
import coalesceGlobalErrorMessage from '@app/libs/coalesceGlobalErrorMessage';
import { modalClose } from '@app/store/modal/actions';

import ConfirmModal from '../ConfirmModal';

interface FileUploadErrorModalProps {
  error: AxiosError;
}

function FileUploadErrorModal({ error }: FileUploadErrorModalProps) {
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(modalClose());
  }, [dispatch]);

  if (error.response && error.response.status === 504) {
    return (
      <ConfirmModal
        closeText="확인"
        content="해당 파일을 업로드 할 수 없습니다.\nPDF파일로 변환하여 다시 업로드해 주세요."
        title="업로드 오류"
        onClose={handleClose}
      />
    );
  }

  if (error.message === 'Pdf file is not editable') {
    return (
      <AlertWithLinkModal
        content="정상적이지 않은 PDF 파일로 업로드가 불가합니다. 해결 방법은 아래 링크를 참고해주세요."
        linkTarget="_blank"
        linkUrl="https://support.modusign.co.kr/hc/ko/articles/4609289606169"
        title="업로드 실패"
      />
    );
  }

  return (
    <ConfirmModal
      closeText="확인"
      content={coalesceGlobalErrorMessage(error.message)}
      title="업로드 실패"
      onClose={handleClose}
    />
  );
}

export default FileUploadErrorModal;
